export const FCFIANCA_REQUESTS_LOADING = 'fcfiancaTable/REQUESTS_LOADING';
export const FCFIANCA_REQUESTS_DONE = 'fcfiancaTable/REQUESTS_DONE';
export const FCFIANCA_REQUESTS_ERROR = 'fcfiancaTable/REQUESTS_ERROR';
export const FCFIANCA_CHANGE_PAGE = 'fcfiancaTable/CHANGE_PAGE';
export const FCFIANCA_CHANGE_PER_PAGE = 'fcfiancaTable/CHANGE_PER_PAGE';
export const FCFIANCA_CHANGE_SORT = 'fcfiancaTable/CHANGE_SORT';
export const FCFIANCA_SET_FILTER = 'fcfiancaTable/SET_FILTER';
export const FCFIANCA_SET_START_DATE = 'fcfiancaTable/SET_START_DATE';
export const FCFIANCA_SET_FINAL_DATE = 'fcfiancaTable/SET_FINAL_DATE';
export const FCFIANCA_RESET_REQUESTS = 'fcfiancaTable/RESET_REQUESTS';